import { selectActiveFeature } from '../../../Map/selectors';
import { TThunkAction } from '../../types/redux';
import { setMapSelection } from '../mapSelection/mapSelection';
import { updateFeatureProperties } from '../updateFeatureProperties/updateFeatureProperies';

export function unsetMapOffer(): TThunkAction {
  return (dispatch, getState) => {
    const activeFeature = selectActiveFeature(getState());

    dispatch(setMapSelection(null));

    if (!activeFeature) {
      return;
    }

    dispatch(
      updateFeatureProperties({
        featureId: activeFeature.id,
        precision: activeFeature.precision,
        properties: { isActive: false },
      }),
    );
  };
}
